import request from '@/utils/request'

let PageApi = {

    /*获取数据*/
    detail(data, errorback) {
        return request._post('/shop/page.page/detail', data, errorback);
    },
    /*上架样式*/
    toAddPage(data, errorback) {
        return request._get('/shop/page.page/add', data, errorback);
    },
    /*上架样式*/
    addPage(data, errorback) {
        return request._post('/shop/page.page/add', data, errorback);
    },
    /*页面列表*/
    PageList(data, errorback) {
        return request._post('/shop/page.page/index', data, errorback);
    },
    /*删除页面*/
    deletePage(data, errorback) {
        return request._post('/shop/page.page/delete', data, errorback);
    },
    /*设为首页*/
    setHome(data, errorback) {
        return request._post('/shop/page.page/setHome', data, errorback);
    },
    /*编辑页面*/
    editHome(data, errorback) {
        return request._get('/shop/page.page/home', data, errorback);
    },
    /*编辑页面*/
    editPage(data, errorback) {
        return request._get('/shop/page.page/edit', data, errorback);
    },
    /*保存编辑页面*/
    SavePage(data, errorback) {
        return request._post('/shop/page.page/edit', data, errorback);
    },
    /*获取分类*/
    getCategory(data, errorback) {
        return request._get('/shop/page.page/category', data, errorback);
    },

    /*提交分类*/
    postCategory(data, errorback) {
        return request._post('/shop/page.page/category', data, errorback);
    },
    /*编辑用户中心页面*/
    editUser(data, errorback) {
        return request._get('/shop/page.page/user', data, errorback);
    },
    /* 保存用户中心页面 */
    saveUser(data, errorback) {
        return request._post('/shop/page.page/user', data, errorback);
    },
    /*编辑商家中心页面*/
    editSupply(data, errorback) {
        return request._get('/shop/page.page/supply', data, errorback);
    },
    /* 保存商家中心页面 */
    saveSupply(data, errorback) {
        return request._post('/shop/page.page/supply', data, errorback);
    },
    /* 编辑底部菜单 */
    editTabbar(data, errorback) {
        return request._get('/shop/page.page/tabbar', data, errorback);
    },
     /* 保存底部菜单 */
     saveTabbar(data, errorback) {
        return request._post('/shop/page.page/tabbar', data, errorback);
    },
    editWebSite(data, errorback) {
        return request._get('/shop/page.page/website', data, errorback);
    },
    saveWebSite(data, errorback) {
        return request._post('/shop/page.page/website', data, errorback);
    },

    // 全局风格
    getGlobalStyleList(data, errorback) {
      return request._get('/shop/page.globalStyle/index', data, errorback);
    },
    /*上架样式*/
    saveStyle(data, errorback) {
      return request._post('/shop/page.globalStyle/save', data, errorback);
    },
    /*设为首页*/
    setDefault(data, errorback) {
      return request._post('/shop/page.globalStyle/setDefault', data, errorback);
    },
    /*删除风格*/
    deleteStyle(data, errorback) {
      return request._post('/shop/page.globalStyle/delete', data, errorback);
    },
    /*编辑页面*/
    editStyle(data, errorback) {
      return request._get('/shop/page.globalStyle/edit', data, errorback);
    },
    /*更新样式*/
    updateStyle(data, errorback) {
      return request._post('/shop/page.globalStyle/update', data, errorback);
    },

}

export default PageApi;



// WEBPACK FOOTER //
// ./src/api/page.js